;(function( window, document, $, undefined ) {
	'use strict';

	// Intro

	function buttons() {

    // Btn Back to top
    function btnBackToTop( $el, $target ) {
      $('body').append('<a href="#" class="btn-backToTop" aria-hidden="true"><i class="fal fa-chevron-up"></i> </a>');
      $('.btn-backToTop').click(function(e){
        e.preventDefault();
        $('html,body').animate({ scrollTop: 0 }, 'slow');
      });

      //if( $('.site-container').height() > $(window).height() ) {
        $(window).scroll(function (event) {
          var scrollPosition = $(window).scrollTop();
          if( scrollPosition > 500 ) {
            $('.btn-backToTop').addClass('active');
          } else {
            $('.btn-backToTop').removeClass('active');
          }
        });
      //}
    }

		// Globals
		return {
      btnBackToTop: btnBackToTop
		};

	}

	// Globals
	window.app = window.app || {};
  window.app.buttons = buttons();

})( window, document, jQuery );
